<template>
  <v-select
    :model-value="selectedLocale"
    @update:model-value="setSelectedLocale"
    :items="locales"
    item-title="label"
    item-value="code"
    :label="$t('global.basicTerms.language')"
    variant="outlined"
    density="compact"
    hide-details
    style="max-width: 180px"></v-select>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

import { useLocaleHelpers } from '@satellite/composables/useLocaleHelpers';
import { usePreferredLanguage } from '@satellite/composables/usePreferredLanguage';

const { userId } = defineProps<{ userId?: string | null }>();

const { locale } = useI18n();
const { setLocale: setUserLocale } = useLocaleHelpers(() => userId ?? undefined);
const { setLocale: setGuestLocale } = useLocaleHelpers();
const { persistPreferredLanguageOnChange } = usePreferredLanguage();

const locales = [
  { code: 'en', label: 'English' },
  { code: 'es-mx', label: 'Español (MX)' },
  { code: 'pt-br', label: 'Portuguese (Brazil)' },
  { code: 'fr-ca', label: 'French Canadian' }
  // Add more as needed
];

const selectedLocale = computed(() => locale.value);
const setSelectedLocale = async (newLocale: string): Promise<void> => {
  locale.value = newLocale;

  if (userId) {
    setUserLocale(newLocale);
    await persistPreferredLanguageOnChange(userId, newLocale);
  }

  setGuestLocale(newLocale);
};
</script>
